
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      //import css for availability and price pages
import '../css/availabilities-rates.css';
import $$ from 'Dom7';
import { translateKey } from 'reword-js';
import actions from '../js/actions.js';
import URLS from '../js/Urls.js';

var moment = require('moment');

var Calendar;
var type = 1;
export default {
  data: function () {
    return {
      events: {},
      RoomsCategories: actions.GetRoomsCatinfo(),
      loginobject: actions.LoginGetResult(),
      BookedRooms: {}
    };
  },
  methods: {
    SelectRoomModal: function (action) {
      this.$app.sheet.open('.select-room-sheet');
      type = action;

      if (type == 3) {
        var RoomsCategories2 = actions.GetRoomsCatinfo().filter(function (value, index, arr) {
          return value.RoomCategoryTitleDefault != "All Rooms";
        });
        this.$setState({
          RoomsCategories: RoomsCategories2
        });
      }
    },

    SelectRoom(roomtype) {
      this.$app.sheet.close('.select-room-sheet');
      var cal = Calendar.getValue();
      var fromdate;
      var todate;

      if (cal) {
        fromdate = cal[0];

        try {
          todate = cal[1];
        } catch {}
      } else {
        fromdate = new Date();
        todate = new Date();
        todate.setDate(todate.getDate() + 1);
      }

      actions.SaveAvailabilityParams(fromdate, todate, roomtype);

      if (type == 1) {
        app.f7.views.main.router.navigate('/room-status/');
      } else if (type == 2) {
        app.f7.views.main.router.navigate('/setup-room-availability/');
      } else if (type == 3) {
        app.f7.views.main.router.navigate('/price-and-limits/');
      } else {}
    }

  },

  beforeDestroy() {
    var self = this;
    Calendar.destroy();
  },

  on: {
    tabInit: async function (e, page) {
      var page = e.detail.page;
      await actions.GetRoomsCategoriers();
      this.$setState({
        RoomsCategories: actions.GetRoomsCatinfo()
      });
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var loginobject = actions.LoginGetResult();
      const UserSpecificApiKey = loginobject?.PropertiesList?.find(property => property.PropertyName == loginobject?.PropertyName)?.UserSpecificApiKey;
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      var now = new Date();
      var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      app.data.currentTab = 4;
      var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      let response;
      Calendar = app.calendar.create({
        containerEl: '#availabilities-calendar-inline-container',
        rangePicker: true,
        weekHeader: false,
        disabled: [{
          from: new Date().minDate,
          to: yesterday
        }],
        events: [{
          date: now,
          color: '#2196f3'
        }],
        renderToolbar: function () {
          return '<div class="toolbar calendar-custom-toolbar no-shadow calendarcustomtoolbar">' + '<div class="toolbar-inner">' + '<div class="left">' + '<a href="#" class="link icon-only"><i class="icon icon-back ' + (app.theme === 'md' ? 'color-black' : '') + '"></i></a>' + '</div>' + '<div class="center"></div>' + '<div class="right">' + '<a href="#" class="link icon-only"><i class="icon icon-forward ' + (app.theme === 'md' ? 'color-black' : '') + '"></i></a>' + '</div>' + '</div>' + '</div>';
        },
        on: {
          monthYearChangeEnd: function () {},
          open: function (c) {
            if (c.value == null) {
              $('.cardlabel').css("display", "none");
            } else {
              var MyDate = c.value[0].getFullYear() + '-' + (c.value[0].getMonth() + 1) + '-' + c.value[0].getDate();
              var dateFrom = c.value[0];
              var dateTo = c.value[1] ?? null;
              Getdata(dateFrom, dateTo);
            } //takis gia events


            var currentmonth = c.currentMonth;
            var currentyear = c.currentYear;
            var currentCalendar = new Date(currentyear, currentmonth, 1);
            var currentCalendar2 = new Date(currentyear, currentmonth, 1);
            var from = currentCalendar;
            var To = currentCalendar2;
            from.setDate(currentCalendar.getDate() - 7);
            To.setDate(currentCalendar2.getDate() + 38);
            var fromStr = moment(from).format('DD-MM-YYYY');
            var toStr = moment(To).format('DD-MM-YYYY');
            GetEventsdata(fromStr, toStr);
          },
          init: function (c) {
            if (c.value != null) {
              GetBookedData();
            }

            $('.icon-forward').on('click', function () {
              $('.cardlabel').css("display", "none");
            });
            $('.calendar-custom-toolbar .center').text(monthNames[c.currentMonth] + ', ' + c.currentYear);
            $('.calendar-custom-toolbar .left .link').on('click', function () {
              c.prevMonth();
            });
            $('.calendar-custom-toolbar .right .link').on('click', function () {
              c.nextMonth();
            });
          },
          monthYearChangeStart: function (c) {
            if (c.value != null) {
              var dateFrom = c.value[0];
              var dateTo = c.value[1] ?? null;
              Getdata(dateFrom, dateTo);
            } else {}

            var currentmonth = c.currentMonth;
            var currentyear = c.currentYear;
            var currentCalendar = new Date(currentyear, currentmonth, 1);
            var currentCalendar2 = new Date(currentyear, currentmonth, 1);
            var from = currentCalendar;
            var To = currentCalendar2;
            from.setDate(currentCalendar.getDate() - 7);
            To.setDate(currentCalendar2.getDate() + 38);
            var fromStr = moment(from).format('DD-MM-YYYY');
            var toStr = moment(To).format('DD-MM-YYYY');
            GetEventsdata(fromStr, toStr);
            $('.calendar-custom-toolbar .center').text(monthNames[c.currentMonth] + ', ' + c.currentYear);
          },
          change: function (c) {
            GetBookedData();
          }
        }
      });
      GetCurrentDate();

      async function GetCurrentDate() {
        var formatedDate = "";
        var d = new Date();
        var month = '' + d.getMonth();
        var day = '' + d.getDate();
        var year = d.getFullYear();
        formatedDate = [year, month, day].join('-');
        $$('[data-date="' + formatedDate + '"]').click();
      } //GetBookedData


      async function GetBookedData() {
        let $selectedDates = $('.calendar-day-selected');
        let dates = [];
        let uniqueSelectedDates = new Set();
        $selectedDates.each(function (index) {
          let date = $(this).attr('data-date');

          if (date) {
            uniqueSelectedDates.add(date);
          }
        });

        if ($(".calendar-day-selected").length > 1 && uniqueSelectedDates.size > 1) {
          $(".card").css("display", "none");
        } else {
          $(".card").css("display", "block");

          if (uniqueSelectedDates.size === 1) {
            let $target = $(event.target);
            let $date = $target.closest(".calendar-day");
            let [year, month, day] = uniqueSelectedDates.values().next().value.split("-");
            month = parseInt(month) + 1;
            var obj = {
              PropertyID: loginobject.PropertyID,
              UserID: loginobject.UserID,
              AvailDate: [day, month, year].join("-"),
              UserSpecificApiKey: UserSpecificApiKey
            };
          }

          try {
            app.preloader.show();
            response = await app.request.promise.postJSON(URLS.GetDayRoomsDetails, {
              obj
            });
            app.preloader.hide();
            self.$setState({
              BookedRooms: response.data
            });
          } catch (error) {
            console.log(error);
          }
        }
      }

      ;

      async function Getdata(dateFrom, dateTo, c) {
        var ResponseGetMonthlyAvailabilityData = {};
        ResponseGetMonthlyAvailabilityData = await actions.GetMonthlyAvailabilityData(dateFrom, dateTo);
        var events = [];
        ResponseGetMonthlyAvailabilityData.forEach(function (item) {
          var re = /-?\d+/;
          var m = re.exec(item.Date);
          var d = new Date(parseInt(m[0]));
          var obj = {
            date: new Date(d.getFullYear(), d.getMonth(), d.getDate()),
            color: '#ff0000'
          };
          var re = /-?\d+/;
          events.push(obj);
        });
        Calendar.params.events = events;
        Calendar.update();
      }

      async function GetEventsdata(dateFrom, dateTo, c) {
        var ResponseGetMonthlyAvailabilityData = {};
        var obj = {
          PropertyID: loginobject.PropertyID,
          UserID: loginobject.UserID,
          DateFrom: dateFrom,
          DateTo: dateTo,
          UserSpecificApiKey: UserSpecificApiKey
        };
        app.preloader.show();
        response = await app.request.promise.postJSON(URLS.GetMonthRoomsDetails, {
          obj
        });
        app.preloader.hide();
        var events = [];
        ResponseGetMonthlyAvailabilityData = response.data;
        ResponseGetMonthlyAvailabilityData.forEach(function (item) {
          var d = moment(item.DateStr, "DD/MM/YYYY").toDate();
          var obj = {
            date: new Date(d.getFullYear(), d.getMonth(), d.getDate()),
            color: item.Color
          };
          var re = /-?\d+/;
          events.push(obj);
        });
        Calendar.params.events = events;
        Calendar.update();
      }
    },
    pageInit: function (e, page) {
      var RoomsCategories = actions.GetRoomsCatinfo();
    },

    pageBeforeRemove() {}

  },
  id: '85de0cf6da',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link icon-only panel-open" data-panel=left><i class="icon f7-icons if-not-md">menu</i> <i class="icon material-icons if-md">menu</i></a></div><div class="title sliding">';
      r += Template7Helpers.t.call(ctx_1, 'AvailabilityAndPrices', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></div><div class="page-content availabilitiespage"><a id=availabilities-calendar-inline-container></a><div style="display: flex;padding: 15px 15px 2px;"><div style="display: flex;align-items: center;margin-right: 5px;"><i class="material-icons lens" style="color: #60C394;margin-bottom: 2px;margin-right: 3px;">lens</i> Available</div><div style="display: flex;align-items: center;margin-right: 5px;"><i class="material-icons lens" style="color: #D2CD3E;margin-bottom: 2px;margin-right: 3px;">lens</i>Min Stay</div><div style="display: flex;align-items: center;"><i class="material-icons lens" style="color: #EC1D27;margin-bottom: 2px;margin-right: 3px;">lens</i> No Avail</div></div><div class="card cardlabel" id=nextbtn><div class="card-content card-content-padding takis"><div class=row style="text-align: center;"><div class=col-33 style="display: grid;"><span>Available</span> <span>';
      r += c(ctx_1.BookedRooms.Availability, ctx_1);
      r += '</span></div><div class=col-33 style="display: grid;"><span>';
      r += Template7Helpers.t.call(ctx_1, 'bookedRooms', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span> <span>';
      r += c(ctx_1.BookedRooms.Occupied, ctx_1);
      r += '</span></div></div></div></div><div class=block><div class=row><a class="col button button-fill calendar-options" @click=SelectRoomModal(1); id=open-close-options><span>';
      r += Template7Helpers.t.call(ctx_1, 'OpenOrCloseRooms', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span></a></div><div class=row><a class="col button button-fill calendar-options" @click=SelectRoomModal(2) id=setup-availability-options><span>';
      r += Template7Helpers.t.call(ctx_1, 'SetupAvailability', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span></a></div><div class=row><a class="col button button-fill calendar-options" @click=SelectRoomModal(3); id=price-limits-options><span>';
      r += Template7Helpers.t.call(ctx_1, 'PriceNLimits', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span></a></div></div></div><div class="sheet-modal select-room-sheet" style="height: 95%;"><div class=toolbar><div class=toolbar-inner><div class=left><a class="link sheet-close"><i class="icon icon-back"></i></a></div></div></div><div class=sheet-modal-inner style=overflow:scroll;><div class=block-title>';
      r += Template7Helpers.t.call(ctx_1, 'SelectRoom', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class="list media-list"><ul>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.RoomsCategories, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<li><a @click=SelectRoom(';
          r += c(ctx_2.RoomCategoryID, ctx_2);
          r += '); class="item-link item-content"><div class=item-media><div class=numberCircle>';
          r += c(ctx_2.RoomCategoryInits, ctx_2);
          r += '</div></div><div class=item-inner><div class=item-title-row style="line-height: 50px;"><div class=item-title>';
          r += c(ctx_2.RoomCategoryTitleDefault, ctx_2);
          r += '</div></div></div></a></li>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</ul></div></div></div></div>';
      return r;
    }(this);
  },

  style: `
  .numberCircle {
    border-radius: 50%;
    width: 30px;
    height: 30px;
    padding: 8px;
    background: #fff;
    border: 2px solid #666;
    color: #666;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .calendar-range .calendar-day.calendar-day-selected .calendar-day-number {
    width: 2rem;
    border-radius: 50%;
    height: 2rem;
  }
`,
  styleScoped: false
};
    